/* eslint-disable react/require-default-props */
import React from 'react';
import { Badge, Button, Image, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  signUpButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '8px',
    minWidth: '280px',
    position: 'relative',
  },
  buttonText: {
    padding: '0 24px',
    display: 'flex',
    justifyContent: 'center',
    flex: 1,
  },
  wideButton: {
    width: '100%',
    marginBottom: tokens.spacingVerticalL,
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
  },
  badge: {
    position: 'absolute',
    top: '50%',
    right: tokens.spacingHorizontalM,
    transform: 'translateY(-50%)',
    color: tokens.colorBrandForeground1,
  },
});

export type IdpButtonProps = {
  buttonClassName: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  dataActionName: string;
  imageClassName: string;
  imageSrc: string;
  textClassName: string;
  textContent: string;
  badgeContent?: string;
  wide?: boolean;
  appearance?: 'primary' | 'secondary' | 'outline' | 'subtle' | 'transparent';
};

export const IdpButton: React.FC<IdpButtonProps> = ({
  buttonClassName,
  onClick,
  dataActionName,
  imageClassName,
  imageSrc,
  textClassName,
  textContent,
  badgeContent,
  wide = false,
  appearance = 'secondary',
}) => {
  const classes = useStyles();

  return (
    <Button
      className={mergeClasses('idp-button', buttonClassName, classes.signUpButton, wide ? classes.wideButton : undefined)}
      onClick={onClick}
      appearance={appearance}
      data-action-name={dataActionName}
    >
      <Image
        className={imageClassName}
        src={imageSrc}
        aria-hidden
      />
      <div className={mergeClasses(textClassName, classes.buttonText)}>
        {textContent}
      </div>
      {badgeContent && (
        <Badge className={mergeClasses('last-used-badge', classes.badge)} appearance="tint" color="brand" shape="rounded" size="large">
          {badgeContent}
        </Badge>
      )}
    </Button>
  );
};
